// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__AEaw8","copyright":"Footer_copyright__2oSaE","copyrightContent":"Footer_copyrightContent__3GCdn"};